import React, {useState} from "react";
import {useStaticQuery, graphql, Link} from "gatsby";
import './header.scss';
import Wrapper from "../Wrapper/wrapper.js";
import {Logo} from "../../elements/Logo/logo.js";
import IconArrow from "../../elements/Icon/iconArrow";

const Header = () => {
    const myQuery = useStaticQuery(query);
    const branch = myQuery.site.siteMetadata.config.branch;
    const config = require("../../../build/config/" + branch + ".json");

    const [stateMenu, setStateMenu] = useState(false);
    const [stateMenuArray, setStateMenuArray] = useState([]);

    const toggleMenu = () => {
        setStateMenu(!stateMenu);
    };
    const closeMenu = () => {
        setStateMenu(false);
    };

    const toggleDropdownMenuArray  = (id) => {
        let itemId = id;
        let new_array = stateMenuArray;
        if (window.innerWidth <= 992) {
            if (new_array.includes(id)) {
                new_array.splice(new_array.indexOf(itemId), 1);
            } else {
                new_array.push(itemId);
            }
            setStateMenuArray(prevArray => [...new_array]);
        }
    };

    let classesMenu = stateMenu ? "m-menu m-menu--open" : "m-menu";

    const itemMenuLi = (item_key, item_url, item_title) => {
        return (
            <li className={"m-menu--item"} key={item_key}>
                <Link to={`/${item_url}/`}>{item_title}</Link>
            </li>
        )
    };

    const itemMenuSecond = (item_key, item_title, sub) => {
        return (
            <li className={"m-menu--item"} key={item_key}>
                <p id={item_key} onClick={() => toggleDropdownMenuArray(item_key)} aria-hidden="true">
                    {item_title}
                    <IconArrow width={13}/>
                </p>
                {sub}
            </li>
        )
    };

    const itemMenuThird = (item_url, item_title, sub_sub_li) => {
        return (
            <li>
                <Link to={`/${item_url}/`}>{item_title}</Link>
                {itemMenuSubSub(sub_sub_li, 'm-menu--submenu--sub')}
            </li>
        )
    };

    const itemMenuSubSub = (sub, className) => {
        return (
            <ul className={className}>
                {sub}
            </ul>
        )
    };

    const itemMenuSub = (id, sub, className) => {
        let classItemMenuSub = (stateMenuArray.includes(id))?className+" d-block":className+" d-none";
        return (
            <ul id={"sub" + id} className={classItemMenuSub}>
                {sub}
            </ul>
        )
    };

    const itemMenuSubLi = (item_url, item_title) => {
        return (
            <li><Link to={`/${item_url}/`}>{item_title}</Link></li>
        )
    };

    let li_menu = [];

    Object.keys(config.menu).forEach((key_main) => {
        let main_itam_menu = config.menu[key_main];
        if (main_itam_menu.sub !== undefined) {
            let sub_li = [];
            Object.keys(main_itam_menu.sub).forEach((key_sub) => {
                let sub_itam_menu = main_itam_menu.sub[key_sub];
                if (sub_itam_menu.sub !== undefined) {
                    //субменю с субсубменю
                    let sub_sub_li = [];
                    Object.keys(sub_itam_menu.sub).forEach((key_sub_sub) => {
                        let sub_sub_itam_menu = sub_itam_menu.sub[key_sub_sub];
                        sub_sub_li.push(itemMenuSubLi(sub_sub_itam_menu.url, sub_sub_itam_menu.title));
                    });
                    sub_li.push(itemMenuThird(sub_itam_menu.url, sub_itam_menu.title, sub_sub_li));
                } else {
                    //субменю список
                    sub_li.push(itemMenuSubLi(sub_itam_menu.url, sub_itam_menu.title))
                }
            });
            if (sub_li.length) {
                li_menu.push(itemMenuSecond(key_main, main_itam_menu.title, itemMenuSub(key_main, sub_li, 'm-menu--submenu')))
            }
        } else {
            li_menu.push(itemMenuLi(key_main, main_itam_menu.url, main_itam_menu.title));
        }
    });

    return (
        <header className="m-header">
            <Wrapper withoutPad>
                <div className="m-menu--burger" onClick={toggleMenu} aria-hidden="true">
                    <div className="burger-icon" >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <Logo />
                <ul className={classesMenu}>

                    {li_menu}

                    <div className={"m-menu--close"} onClick={closeMenu} aria-hidden="true">x</div>
                </ul>
            </Wrapper>
        </header>
    )
}

export default Header;

const query = graphql`
  query Country {
    site {
      siteMetadata {
        config {
          branch
        }
      }
    }
  }
`;